import styled from 'styled-components'

export default styled.article`
  width: 800px;
  border-radius: 5px;
  background-color: ${ ({ theme }) => theme.colors.white };
  box-shadow: 0px 4px 4px 0px #00000040;
  height: 100%;
  min-height: 700px;
  box-sizing: border-box;
  overflow: hidden;
  margin: 50px auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .spinner-container {
    display: flex;
    justify-content: center;
    padding: 8px 0;
  }

  header {
    min-height: 70px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    margin: 8px 0px 8px 0px;
    gap: 8px;

    .row {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }

    .modeButton {
      display: flex;
      flex-direction: row;
      justify-content: stretch;
      align-items: stretch;
      background-color: transparent;
      margin: 0;
      padding: 8px 0 0 0;      

      .separator {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 2px;
        flex-shrink: 0;
        align-self: center;
        height: 30px;
        background-color: ${ ({ theme }) => theme.colors.grey };        
      }

      label {
        flex: 1;
        font-size: 18px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 20px;
        color: ${({ theme }) => theme.colors.greyDark};
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        text-align: center;

        &.selected {
          font-weight: 700;
          line-height: 14px;

          &::after {
            content: '';
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            width: 200px;
            max-width: 100%;
            bottom: -5px;
            height: 4px;
            background: ${({ theme }) => theme.colors.purple};
          }
        }
      }
    }


    

    h3 {
      color: ${ ({ theme }) => theme.colors.primary };
      font-size: 18px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 20px;
      margin: 0;
    }

    button {
      font-family: ${ ({ theme }) => theme.fontFamily };
      font-size: 18px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 20px;
      background-color: transparent;
      border: none;
      color: ${ ({ theme }) => theme.colors.primary };
      padding: 0;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      cursor: pointer;

      img {
        margin-right: 10px;
        height: 20px;
        width: auto;
      }
    }
  }

  > section {
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    flex-wrap: nowrap;
    padding: 0px 20px 5px 20px;
    background-color: ${ ({ theme }) => theme.colors.white };

    > section:last-child {
      flex: 1;
      display: flex;
      flex-direction: column;
    }
  }

  &.fit-viewport {
    height: calc(100vh - 180px);
    max-height: calc(100vh - 180px);
    min-height: 0;
    flex: none;

    > section.bus-stops {
      flex: 1;
      height: auto;
      min-height: 0;

      > *:last-child {
        flex: 1;
        min-height: 0;
        display: flex;
        flex-direction: column;
      }
    }

    > footer {
      flex-shrink: 0;
    }

    @media screen and (max-width: 768px) {
      margin: 0;
      height: calc(100vh - 80px);
      max-height: calc(100vh - 80px);
    }
  }

  > div {
    overflow: hidden;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  > div > .card-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding-bottom: 80px;
  }
   
  .details-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    padding-top: 0;
    
    &.iframe {
      align-items: center;
    }

    .info-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 16px;
      width: 100%;

      .seats-container {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        gap: 32px;
      }
      
      &.iframe {
        flex-direction: row;
        gap: 40px;

        > section {
          width: unset; 
        }

        label {
          width: max-content;
        }
      }
    }

    .direction-container {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 4px;
      font-size: 18px;
      font-weight: 700;
      width: max-content;

      img {
        width: 24px;
        height: 24px;

        &.return {
          rotate: 180deg;
        }
      }
    }
  }

  .details-separator {
    width: 100%;
    height: 24px;
    background-color: ${ ({ theme }) => theme.colors.almostWhite };
  }

  footer {
    margin: 0;
    padding: 0 20px 20px;

    .buttons-wrapper {
      min-height: 50px;
      display: flex;
      flex-direction: row-reverse;
      justify-content: center;
      align-items: center;
      gap: 16px;
      padding: 10px 0 0;
      position: relative;
    }

    .buttons-container {
      display: flex;
      flex-direction: row;
      justiy-content: flex-end;
      align-items: flex-end;
      gap: 8px;
    }

    button {
      width: 230px;
    }

    .radiobuttons-container {
      display: flex;
      flex-direction: row;
      gap:  24px;
      padding-left: 30px;

      label {
        font-size: 16px;
      }
    }
  }

  .map {
    width: calc(100%);
    min-height: 200px;
    flex: 2;
    border-radius: 10px;
    box-sizing: border-box;
  }

  .stops-summary-container {
    display: flex;
    flex-direction: row;
    margin: 24px 4px 10px 4px;
    min-height: 70px;
    padding-left: 25px;
  }

  .stops-summary-container.single {
    align-items: center;
  }

  .stops-summary {
    flex: 0 0 auto;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    div:not(.dashed) {
      width: calc(100% - 60px);
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      
      span {
        font-family: ${ ({ theme }) => theme.fontFamily };
        font-size: 18px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 20px;
        color: ${ ({ theme }) => theme.colors.greyDark };
        margin-left: 14px;

        &.placeholder {
          color: ${ ({ theme }) => theme.colors.grey };
          font-weight: normal;
        }

        /* Address under the pin, not confirmed yet. */
        &.preview {
          color: ${ ({ theme }) => theme.colors.greyMedium };
          font-weight: normal;
          font-style: italic;
        }
      }

      .reset-button {
        cursor: pointer;
        justify-content: flex-end;
        width: 20%;
      }
    }

    .dashed {
      border-left: 2px dotted ${ ({ theme }) => theme.colors.grey };
      margin: -4px 0 -4px 9px;
      height: 25px;
    }
  }

  .search-bar-container {
    position: relative;
    
    .search-results-container {
      position: absolute;
      width: calc(100% - 42px);
      max-height: 360px;
      overflow: auto;
      top: 50px;
      background-color: ${ ({ theme }) => theme.colors.white };
      border: solid 1px ${ ({ theme }) => theme.colors.grey };
      border-radius: 0 0 4px 4px;
      z-index: 2;
    }

    .filter-container {
      margin: 0 20px;
      position: absolute;
      top: 55px;
      right: 0;
      width: 40%;
      background-color: ${ ({ theme }) => theme.colors.white };
      border: solid 1px ${ ({ theme }) => theme.colors.grey };
      border-radius: 4px;
      z-index: 2;
      padding: 16px;

      .filter-header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 8px;
        
        .title {
          font-size: 22px;
          font-weight: bold;
        }

        .close-icon {
          cursor: pointer;
        }
      }
    }
  }

  .link-action {
    color: ${ ({ theme }) => theme.colors.blueLight };
    font-size: 14px;
    text-decoration: underline;
    cursor: pointer;
  }


  .card-container {
    padding: 0px 24px 24px 24px;
  }

  .availabilities-container {
    max-height: 50vh;
  }

  .skeleton-weekdays {
    display: flex;
    margin: 4px 0 8px;
    overflow: hidden;
  }

  .skeleton-card {
    background: linear-gradient(90deg, ${ ({ theme }) => theme.colors.greyLight } 25%, ${ ({ theme }) => theme.colors.almostWhite } 50%, ${ ({ theme }) => theme.colors.greyLight } 75%);
    background-size: 200% 100%;
    animation: skeleton-loading 1.5s infinite;
    border-radius: 8px;
  }

  .skeleton-weekday-card {
    flex: 0 0 auto;
    width: 10%;
    height: 56px;
    margin-right: 16px;
  }

  @keyframes skeleton-loading {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }

  @media screen and (max-width: 768px) {
    .skeleton-weekday-card {
      width: 25%;
    }
  }

  &.split {
    background-color: transparent;
    box-shadow: none;
    overflow: auto;

    > div {
      display: flex;
      flex-direction: column;
      height: 100%;
      gap: 24px;
      overflow: visible;
      background-color: ${ ({ theme }) => theme.colors.white };
    }

    > div > header {
      position: sticky;
      top: 0;
      z-index: 5;
      background-color: ${ ({ theme }) => theme.colors.white };
    }

    header {
      background-color: ${ ({ theme }) => theme.colors.white };
      margin: 0;
      padding: 8px 0 0 0;
    }

    .card-container {
      background-color: ${ ({ theme }) => theme.colors.white };
      padding: 0px 24px 24px 24px;
      border-radius: 5px;
      box-shadow: 0px 4px 4px 0px #00000040;

      &:first-of-type {
        border-radius: 0 0 5px 5px;
      }
    }
    
    .availabilities-container {
      max-height: 125px;
    }

    > div > .card-container {
      flex: 1;
      overflow: visible;
      padding-bottom: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    > div > .card-container:last-of-type {
      padding-bottom: 80px;
    }

    footer {
      margin: 0 0 8px 0;
      .buttons-wrapper {
        padding: 24px 0 0;
        background-color: transparent;
      }
    }
  }

  &.iframe {
    width: 100%;
    box-shadow: none;
    margin: 0;
    min-height: 100%;
    flex: 1;

    header {
      display: flex;
      flex-direction: row;
      justify-content: stretch;
      align-items: stretch;
      background-color: transparent;
      margin: 0;
      padding: 8px 0 0 0;

      .separator {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 2px;
        flex-shrink: 0;
        align-self: center;
        height: 30px;
        background-color: ${ ({ theme }) => theme.colors.grey };        
      }

      label {
        flex: 1;
        font-size: 18px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 20px;
        color: ${({ theme }) => theme.colors.greyDark};
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        text-align: center;

        &.selected {
          font-weight: 700;
          line-height: 14px;

          &::after {
            content: '';
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            width: 200px;
            max-width: 100%;
            bottom: 15px;
            height: 4px;
            background: ${({ theme }) => theme.colors.purple};
          }
        }
      }
    }

    header {
      display: flex;
      flex-direction: row;
      justify-content: stretch;
      align-items: stretch;
      background-color: transparent;
      margin: 0;
      padding: 8px 0 0 0;      

      .separator {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 2px;
        flex-shrink: 0;
        align-self: center;
        height: 30px;
        background-color: ${ ({ theme }) => theme.colors.grey };        
      }

      label {
        flex: 1;
        font-size: 18px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 20px;
        color: ${({ theme }) => theme.colors.greyDark};
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        &.selected {
          font-weight: 700;
          line-height: 14px;

          &::after {
            content: '';
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            width: 200px;
            bottom: 15px;
            height: 4px;
            background: ${({ theme }) => theme.colors.purple};
          }
        }
      }
    }

    > section {
      overflow: auto;
      flex: 1;
      height: auto;
      padding-bottom: 80px;

      &.no-footer {
        padding-bottom: 8px;
      }

      > section:last-child {
        flex: 1;
        display: flex;
        flex-direction: column;

        > section {
          flex: 1;
          display: flex;
          flex-direction: column;
        }
      }
    }

    .map {
      min-height: 100px;
      max-height: none;
      flex: 1 1 0;
      margin-bottom: 16px;
    }

    > div {
      display: flex;
      flex-direction: column;
      flex: 1;
      overflow: auto;
      padding-bottom: 80px;

      > .card-container {
        margin: auto 0 !important;
        box-shadow: 0 4px 4px 0 rgba(183, 189, 204, 0.20);
      }
    }

    &.split > div > .card-container {
      margin: 0 !important;
    }

    &.split > div {
      overflow: visible;
      // min-height: 100dvh;
      height: 100%;
    }

    &.split > div > .card-container {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    &.split > div > .card-container:last-of-type {
      padding-bottom: 80px;
    }

    &.split {
      overflow: hidden;
    }

    @media screen and (max-width: 768px) {
      &.split {
        padding-bottom: 36px;
      }
    }

    &.split > div > .card-container {
      min-height: 0;
    }

    &.split > div > .card-container > section:last-child {
      min-height: 0;
      height: auto;
    }

    &.split .availabilities-container {
      max-height: none;
    }

    .card-container {
      box-shadow: none;
      padding: 0px 24px 10px 24px;
    }

    footer {
      position: fixed;
      bottom: 0;
      width: calc(100% - 40px);
      margin: 0;
      padding: 0 20px 20px;
      background-color: white;

      .buttons-wrapper {
        justify-content: space-between;
        gap: 0;
        padding: 10px 0 0;
      }
    }
  }

  @media screen and (max-width: 768px){
    width: 100%;
    margin: 0 0 105px;

    > div {
      height: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    }

    &:not(.split) > div > .card-container {
      overflow: auto;
      padding-bottom: 48px;
    }

    &.split > div > .card-container {
      flex: 1;
      overflow: visible;
      padding-bottom: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    &.split > div > .card-container:last-of-type {
      padding-bottom: 80px;
    }

    &.split {
      overflow: auto;
    }

    &.split > div {
      overflow: visible;
      height: 100%;
    }

    &.split > div > header {
      position: sticky;
      top: 0;
      z-index: 5;
      background-color: white;
    }

    > section {
      overflow: auto;
      margin-bottom: 125px;
    }
    
    > section.bus-stops {
      margin-bottom: 180px;
    }

    > section.bus-stops.no-footer {
      margin-bottom: 16px;
    }

    header {
      margin: 0;
      min-height: 40px;
      padding-top: 8px;

      .modeButton {
        padding-top: 0;
      }
    }

    &.iframe header {
      min-height: 50px;
      padding-top: 0;

      label.selected::after {
        bottom: 8px;
      }
    }

    &.iframe footer .buttons-wrapper {
      gap: 4px;
    }

    .details-wrapper {
      flex-direction: column-reverse;
      gap: 20px;

      .info-container {
        flex-direction: column !important;
        gap: 16px !important;
        
        > section {
          width: 100% !important; 
        }

        .seats-container {
          flex-direction: column;
          gap: 8px;
        }
      }
    }

    &.iframe:not(.split) > div {
      display: flex;
      flex-direction: column;
      height: 100%;
    }

    &.iframe:not(.split) > div > .card-container {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    &.iframe > section {
      padding-bottom: 0;
      flex: 1;
      height: auto;
      margin-bottom: 90px;
      display: flex;
      flex-direction: column;

      > section:last-child {
        flex: 1;
        display: flex;
        flex-direction: column;

        > section {
          flex: 1;
          display: flex;
          flex-direction: column;
        }
      }
    }

    .direction-container {
      width: 100%;
    }

    .stops-summary-container {
      margin: 16px 0 10px 0;
    }

    .radiobuttons-container {
      margin: 12px 0;
    }

    footer {
      .buttons-wrapper {
        padding: 8px 16px;
        display: flex;
        flex-direction: column-reverse;
        gap: 8px;
      }

      position: fixed;
      bottom: 0;
      fixed: 0;
      background-color: ${ ({ theme }) => theme.colors.white };
      width: calc(100% - 32px);
      z-index: 10;
      padding: 8px 16px;
      margin: 0 !important;

      .buttons-container {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 8px;
      }

      button {
        width: 100%;
      }
    }
  }
`
